"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.openPdf = void 0;
const openPdf = (base64Pdf, name = 'document') => {
    const pdfBLob = new Blob([base64Pdf], {
        type: 'application/pdf',
    });
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(pdfBLob, `${name}.pdf`);
    }
    else {
        const url = URL.createObjectURL(pdfBLob);
        window.open(url, '_blank');
    }
};
exports.openPdf = openPdf;
